import React, { Fragment } from 'react'

import { MarketNewsStyled, MarketNewsContentStyled, MarketNewsListStyled, MarketNewsListItemStyled, MarketNewsCtaStyled } from './styles'
import Button from './../../atoms/Button'
import NewsBox from '../../molecules/NewsBox'
import { MarketNewsProps } from './types'

import useXclient from '../../../hooks/useXclient'
import generatePath from '../../../utils/generatePath'
import { Routes } from '../../../setup/consts'
import usePageContext from '../../../hooks/usePageContext'

const MarketNews: React.FC<MarketNewsProps> = ({ data }) => {
  const { lang, group } = usePageContext()
  const { client, cta } = data

  const { data: dataArray } = useXclient({ container: '#xclient-container', limit: 4, ...client })

  return (
    <Fragment>
      <div id="xclient-container"></div>
      <MarketNewsStyled>
        {dataArray.length ? (
          <MarketNewsContentStyled>
            <MarketNewsListStyled>
              <MarketNewsListItemStyled>
                <NewsBox data={dataArray[0]} url={generatePath(Routes.MarketNews, { slug: dataArray[0].slug, lang, group })} />
              </MarketNewsListItemStyled>
              {dataArray.slice(1, 4).map((el) => (
                <MarketNewsListItemStyled key={el.id}>
                  <NewsBox data={el} isSmall url={generatePath(Routes.MarketNews, { slug: el.slug, lang, group })} />
                </MarketNewsListItemStyled>
              ))}
            </MarketNewsListStyled>
          </MarketNewsContentStyled>
        ) : (
          ''
        )}
        {cta && (
          <MarketNewsCtaStyled>
            <Button
              variant="withArrow"
              url={cta.url}
              urlText={cta.urlText}
              urlIsExternal={cta.urlIsExternal}
              urlIsLogin={cta.urlIsLogin}
              urlIsRegister={cta.urlIsRegister}
            />
          </MarketNewsCtaStyled>
        )}
      </MarketNewsStyled>
    </Fragment>
  )
}

export default MarketNews
